(function($) {
    'use strict';

    class Calculator {
        constructor() {
            this.init();
        }

        init() {
            this.endpoint = salaryCalculatorData.ajaxurl;
            this.nonce = salaryCalculatorData.nonce;
        }

        calculate(formData) {
            return $.ajax({
                url: this.endpoint,
                type: 'POST',
                data: {
                    action: 'calculate_salary',
                    nonce: this.nonce,
                    ...formData
                }
            });
        }
    }

    window.Calculator = Calculator;

})(jQuery); 